import { message } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { trackQueryError } from '@src/utils/sensor/apptracker';
import { setDefaultAccount } from '@src/api/applications';

const useSetDefaultAccount = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    (payload: any) => {
      return setDefaultAccount(payload);
    },
    {
      onSuccess: (response) => {
        if (response.data === 'OK') {
          queryClient.invalidateQueries(['profile', 'applications']);
          message.success(`Default account updated successfully!`);
        }
      },
      onError: (err) => {
        trackQueryError({ type: 'update-default-account', err });
      },
    },
  );

  return mutation;
};

export default useSetDefaultAccount;
